"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nTextResource = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const I18nText_1 = require("../../types/I18nText");
const Resource_1 = __importDefault(require("../Resource"));
class I18nTextResource extends Resource_1.default {
}
exports.I18nTextResource = I18nTextResource;
__decorate([
    (0, class_validator_1.IsIn)(I18nText_1.ISO639Keys),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], I18nTextResource.prototype, "lang", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], I18nTextResource.prototype, "text", void 0);
